<mat-card appearance="outlined" ngClass="cardWithBackground">
  <mat-card-content>
    <table class="mat-mdc-table fullWidth">
      <thead>
        <tr class="mat-mdc-header-row">
          <th class="mat-mdc-header-cell left">Namn</th>
          <th class="mat-mdc-header-cell left">Uppfylld</th>
          <th class="mat-mdc-header-cell left">Tidigare uppfylld</th>
          <th class="mat-mdc-header-cell left">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        @for (reportStandard of reportStandards; track reportStandard) {
          <tr class="mat-mdc-row">
            <td class="mat-mdc-cell">{{ reportStandard.name }}</td>
            <td class="mat-mdc-cell">{{ getFulfillText(reportStandard.fulfilled) }}</td>
            <td class="mat-mdc-cell">{{ getFulfillText(reportStandard.previousFulfilled) }}</td>
            <td class="mat-mdc-cell">
              <button mat-button color="primary" (click)="showDetails($event, reportStandard)">Ja/Nej</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </mat-card-content>
</mat-card>
